$(document).ready(function(){
   	$('.multiple-items').slick({
            infinite:true,
            slidesToShow:4,
            slidesToScroll: 1,
            arrows:true,
            autoplay:false,
            autoplaySpeed:500,
            responsive :[
                {
                    breakpoint:992,
                    settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1 ,
                    autoplay:false,
                    autoplaySpeed:500, 
                    }
                },
                {
                    breakpoint:768,
                    settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    autoplay:false,
                    autoplaySpeed:500, 
                    }
                }
            ]
        });
   $('.home_slider').slick({
            infinite:true,
            slidesToShow:1,
            slidesToScroll: 1,
            arrows:false,
            dots:true,
            autoplay:false,
            autoplaySpeed:500 
        });
  	if ($(document).width()<767){
      $('.how-works').slick({
              infinite:true,
              slidesToShow:4,
              slidesToScroll: 1,
              arrows:true,
              autoplay:false,
              autoplaySpeed:500,
              responsive :[
                  {
                      breakpoint:768,
                      settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1,
                      autoplay:false,
                      autoplaySpeed:500, 
                      }
                  }
              ]
          });
    }
  

  
  
//   $(".accordion").accordion({ 
//         heightStyle: "content" 
//   });
//   $(".faq-wrap .acc-head").click(function(){
//             $('.acc-head').removeClass('active-accordion');
//             $('.answer-details').slideUp();
//             $('.faq-wrap').removeClass('acc-active');
//             $(this).addClass('active-accordion');
//             $(this).next('.answer-details').slideDown();
//     });
  

$('.toggle').click(function(e) {
    e.preventDefault();
    var $this = $(this);
    if($this.hasClass('active-menu')) {
        $this.removeClass('active-menu');
        $this.next().removeClass('show');
         $this.next().slideUp(350);
     }
     else{
        if($this.parent().parent().find('.toggle').hasClass('active-menu')){
        	var nextt = $this.parent().parent().find('.toggle');
            nextt.removeClass('active-menu');
        nextt.next().removeClass('show');
         nextt.next().slideUp(350)
        }
       $this.addClass('active-menu');
       $this.next().addClass('show');
         $this.next().slideDown(350);
      }
   });
  
  $('.header__icon--account').click(function(e) {
    e.preventDefault();
    $('.loginPopUp').show();
  });
  $('.loginPopUp .cross-icon  img').click(function(){
  $('.loginPopUp').hide();
  }); 
  // happy customers slick
  $('.happy-slick').slick({
            infinite:true,
            slidesToShow:3,
            slidesToScroll: 1,
            arrows:true,
            autoplay:false,
            autoplaySpeed:500,
            responsive :[
                {
                    breakpoint:992,
                    settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1 ,
                    autoplay:false,
                    autoplaySpeed:500, 
                    }
                }
            ]
        });
  
});